// extracted by mini-css-extract-plugin
module.exports = {"header":"TourList_header__1ztPp","content":"TourList_content__1TD5Q","card":"TourList_card__WtlCE","table":"TourList_table__AejzM"};